import { format } from 'date-fns';
import { useState } from 'react';

import { DatePickerModalProps } from './DatePickerModal';

interface DateState {
  startDate: Date | null;
  endDate: Date | null;
}

const useDatePickerModal = ({
  handleChangeDate,
  onClose,
}: Pick<DatePickerModalProps, 'handleChangeDate' | 'onClose'>) => {
  const [optionSelected, setOptionSelected] = useState(0);
  const [dates, setDates] = useState<DateState>({ startDate: null, endDate: null });

  const handleOptionSelected = (option: number) => {
    setOptionSelected(option);
  };

  const formatDate = (date: Date | null) => (date ? format(date, 'yyyy-MM-dd') : '');

  const handleOneDateChange = (date: Date | null) => {
    setDates({ startDate: date, endDate: date });
  };

  const submitDates = () => {
    if (dates.startDate === null || dates.endDate === null) return;

    const formattedStartDate = formatDate(dates.startDate);
    const formattedEndDate = formatDate(dates.endDate);
    handleChangeDate({ startDate: formattedStartDate, endDate: formattedEndDate });
    onClose();
  };

  return {
    optionSelected,
    dates,
    setDates,
    handleOptionSelected,
    handleOneDateChange,
    formatDate,
    submitDates,
  };
};

export default useDatePickerModal;
